// extracted by mini-css-extract-plugin
export default {"container":"_59df81a6194b47a9"};